"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as t, jsxs as w, Fragment as k } from "react/jsx-runtime";
import * as o from "react";
import E from "classnames";
import { SkeletonAnimation as V } from "./skeletons.js";
import { AspectRatioContainer as _ } from "./utils/aspect-ratio-support.js";
import { getPrefixedDataAttributes as Z } from "./utils/dom.js";
import { useIsInverseVariant as z } from "./theme-variant-context.js";
import { useTheme as F, useAriaId as T } from "./hooks.js";
import { VIVO_SKIN as O, VIVO_NEW_SKIN as j } from "./skins/constants.js";
import { sprinkles as D } from "./sprinkles.css-mistica.js";
import { circularBorderRadius as $, noBorderRadius as p, defaultBorderRadius as K, FADE_IN_DURATION_MS as P, image as U, imageWithBorder as q } from "./image.css-mistica.js";
import { vars as r } from "./skins/skin-contract.css-mistica.js";
import { combineRefs as G } from "./utils/common.js";
import J from "./skeleton-base.js";
import { isServerSide as Q } from "./utils/environment.js";
const X = (param)=>{
    let { style: e } = param;
    return /* @__PURE__ */ t("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        style: e,
        children: /* @__PURE__ */ t("path", {
            d: "M24.021 35.7235C24.8145 35.7694 25.0467 36.1913 25.3157 36.5138C25.586 36.8362 29.515 41.551 29.7823 41.8569C30.0475 42.1662 30.7822 42.7329 31.5901 42.8405C32.3967 42.9473 33.282 42.7842 33.8484 42.3748C34.4135 41.965 35.1313 41.4073 35.3833 41.0356C35.6337 40.6638 36.061 40.1302 35.9823 39.2534C35.9028 38.3783 35.7112 37.9204 35.0268 37.1691C34.3433 36.4185 30.2992 31.6657 29.5382 30.7537C29.5382 30.7537 28.8467 29.9423 28.9469 28.7956C29.0476 27.6468 29.567 27.1343 30.6608 26.8487C31.7534 26.5647 36.0267 25.5306 36.0267 25.5306C36.0267 25.5306 38.4728 24.3723 37.9182 22.0776L37.5997 20.904C37.5997 20.904 37.0672 18.2264 33.5519 19.0556C30.0344 19.8869 28.0803 20.377 28.0803 20.377C28.0803 20.377 26.9602 20.4838 26.7999 19.744C26.6417 19.0038 26.8494 18.6218 27.3443 18.4156C27.8387 18.209 30.9611 16.7175 31.3617 12.6853C31.7652 8.65158 28.3882 5.06573 24.0091 5.08104C19.6288 5.0976 16.4594 8.39988 16.4725 11.8185C16.4856 15.2387 18.7033 17.5144 20.4079 18.3638C21.3752 18.8453 21.0656 19.7122 21.0656 19.7122C21.0656 19.7122 20.8334 20.5554 19.8153 20.3311C18.7972 20.1025 13.8657 18.9736 13.8657 18.9736C13.8657 18.9736 10.8914 18.4226 10.1732 21.359C9.4541 24.2978 11.1261 25.4143 12.3532 25.6908C13.5798 25.9669 17.7296 26.9716 17.7296 26.9716C17.7296 26.9716 18.9643 27.581 19.0125 28.8308C19.0425 29.5697 19.0438 30.1824 18.266 31.2832C17.4894 32.3835 12.6598 38.0148 12.6598 38.0148C12.6598 38.0148 10.9997 39.9862 13.4051 41.763C15.8106 43.5401 17.1641 43.1262 18.5921 41.4889C20.0188 39.852 22.8383 36.4243 22.8383 36.4243C22.8383 36.4243 23.2275 35.6788 24.021 35.7235Z",
            stroke: r.colors.brand,
            strokeWidth: "2"
        })
    });
}, Y = /*#__PURE__*/ o.forwardRef((param, s)=>{
    let { borderRadius: e, withIcon: C = !0, border: d, className: m } = param;
    const a = z(), { skinName: n } = F();
    return /* @__PURE__ */ t("div", {
        style: {
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: a ? r.colors.backgroundSkeletonInverse : r.colors.backgroundSkeleton,
            boxSizing: "border-box",
            border: d ? `1px solid ${r.colors.borderLow}` : "none",
            borderRadius: e
        },
        ref: s,
        className: m,
        children: C ? n === O ? /* @__PURE__ */ t(X, {
            style: {
                width: "10%",
                minWidth: 24,
                maxWidth: 48
            }
        }) : n === j ? /* @__PURE__ */ w("svg", {
            viewBox: "0 0 24 24",
            role: "presentation",
            style: {
                width: "10%",
                minWidth: 24,
                maxWidth: 48
            },
            children: [
                /* @__PURE__ */ t("path", {
                    d: "M5.60044 14.585C5.49637 14.585 5.3983 14.5458 5.32396 14.4744L4.73612 13.9003C4.72555 13.8898 4.71068 13.8837 4.69552 13.8837C4.68037 13.8837 4.66579 13.8895 4.65493 13.9L4.06852 14.4698C3.99418 14.5411 3.89611 14.5806 3.79203 14.5806C3.68796 14.5806 3.59018 14.5411 3.5167 14.4698C3.36545 14.3226 3.36517 14.0833 3.5167 13.9361L4.10454 13.365C4.12656 13.3435 4.12656 13.3087 4.10454 13.2872L3.5167 12.7161C3.36517 12.5689 3.36517 12.3296 3.5167 12.1824C3.59047 12.1111 3.68796 12.0716 3.79203 12.0716C3.89611 12.0716 3.99389 12.1111 4.06737 12.1824L4.65407 12.7525C4.66493 12.763 4.67951 12.7687 4.69467 12.7687C4.70982 12.7687 4.7244 12.763 4.73527 12.7525L5.32511 12.1794C5.39859 12.108 5.49637 12.0686 5.60044 12.0686C5.70451 12.0686 5.80229 12.108 5.87577 12.1794C6.02731 12.3266 6.02731 12.5659 5.87577 12.7131L5.28479 13.2872C5.26278 13.3087 5.26278 13.3435 5.28479 13.365L5.87577 13.9391C6.02674 14.0858 6.02674 14.3256 5.87606 14.4739C5.80258 14.5456 5.70451 14.585 5.60044 14.585Z",
                    fill: a ? r.colors.inverse : r.colors.neutralMedium
                }),
                /* @__PURE__ */ t("path", {
                    d: "M13.0142 10.7496C12.953 10.7471 12.8819 10.7471 12.8132 10.7521H12.7598C12.2257 10.7571 10.2337 10.9373 10.2337 13.3694C10.2337 15.8061 12.2431 15.9965 12.7775 16.004H12.8638C12.8913 16.004 12.9193 16.0034 12.9465 16.0026C12.9725 16.0021 12.9979 16.0015 13.0214 16.0015C13.5326 15.9916 15.5677 15.8039 15.5677 13.3818C15.5683 10.9646 13.5357 10.762 13.0142 10.7496ZM13.0042 14.9461L12.8644 14.9485H12.7958C11.3282 14.9262 11.3282 13.7525 11.3282 13.3669C11.3282 12.9837 11.3282 11.8147 12.7729 11.8026H12.8161C12.8747 11.8026 12.9356 11.8026 12.9891 11.8051C14.4773 11.8395 14.4773 13.0011 14.4773 13.3818C14.477 13.7631 14.4761 14.9191 13.0042 14.9461Z",
                    fill: a ? r.colors.inverse : r.colors.neutralMedium
                }),
                /* @__PURE__ */ t("path", {
                    d: "M21.9997 17.2968H21.9971V9.45494C21.9971 8.78512 21.7301 8.39233 21.5062 8.17981C21.1062 7.80217 20.6039 7.76579 20.4609 7.75559L20.454 7.75506C20.4397 7.75398 20.4298 7.75324 20.4249 7.75228L15.6707 7.74732L14.9331 6.52152C14.7398 6.20012 14.3813 6 13.9996 6H12.0179C11.6033 6 11.2319 6.22493 11.0487 6.58575L10.4611 7.74732C8.26329 7.74732 6.43945 7.7498 5.96626 7.75228C5.21574 7.75476 4.79373 8.04391 4.56986 8.28372C4.10439 8.79036 4.16043 9.43537 4.16529 9.45274L4.16872 10.7C3.54515 10.7764 3.04937 10.9895 2.69141 11.3373C2.23395 11.7819 2.00208 12.4443 2.00208 13.3063C2.00208 14.1677 2.23395 14.8298 2.69141 15.2741C3.05252 15.6247 3.55372 15.8383 4.18502 15.913L4.18845 17.3119C4.23162 18.723 5.25176 18.9975 5.67148 18.9975L20.4275 19C21.005 19 21.3584 18.7627 21.552 18.5626C22.038 18.0628 22.0048 17.3412 21.9997 17.2968ZM2.78205 13.306C2.78205 12.6444 2.93301 12.1758 3.24408 11.8737C3.55516 11.5713 4.03692 11.4242 4.71739 11.4242H4.72254C5.39786 11.4242 5.87763 11.57 6.1887 11.8704C6.50263 12.1734 6.65474 12.6431 6.65417 13.3063C6.65417 13.9673 6.50292 14.4353 6.19184 14.7374C5.88077 15.0395 5.39844 15.1864 4.71768 15.1864C4.03749 15.1864 3.55544 15.0395 3.24465 14.7374C2.93301 14.435 2.78205 13.967 2.78205 13.306ZM20.7534 17.8428C20.7102 17.8872 20.6287 17.9468 20.4277 17.9514L5.65633 17.949L5.65394 17.9485L5.65244 17.9483L5.64947 17.9479C5.59908 17.9415 5.29865 17.9037 5.27978 17.3015L5.27607 15.9089C5.8782 15.8328 6.36168 15.628 6.71678 15.2959C7.19311 14.8504 7.43471 14.1809 7.43471 13.3057C7.43471 12.4305 7.19311 11.7607 6.71678 11.315C6.35796 10.9793 5.86848 10.7734 5.25805 10.6992L5.25434 9.40064C5.25176 9.39816 5.23918 9.15091 5.38414 8.99296C5.49107 8.87443 5.6895 8.81489 5.97169 8.81269C6.4703 8.80773 8.45667 8.80773 10.8019 8.80773C11.0103 8.80773 11.2016 8.69168 11.2931 8.51113L12.0182 7.05793L13.987 7.05297L14.885 8.54311C14.9817 8.70381 15.1624 8.80497 15.3582 8.80497L20.4355 8.80745C20.438 8.80745 20.6187 8.81737 20.7408 8.93342C20.8503 9.03486 20.9035 9.21017 20.9035 9.45494L20.9061 17.3312C20.9109 17.388 20.8984 17.6921 20.7534 17.8428Z",
                    fill: a ? r.colors.inverse : r.colors.neutralMedium
                })
            ]
        }) : // We cannot use IconImageRegular because we want to avoid the usage of width and height props to allow this icon to be responsive
        /* @__PURE__ */ t("svg", {
            viewBox: "0 0 24 24",
            role: "presentation",
            style: {
                width: "10%",
                minWidth: 24,
                maxWidth: 48
            },
            children: /* @__PURE__ */ t("path", {
                fill: a ? r.colors.inverse : r.colors.neutralMedium,
                d: "M20.25 4.622c.832 0 1.591.664 1.591 1.393v11.98c0 .728-.76 1.392-1.591 1.392H3.746c-.863 0-1.591-.639-1.591-1.392V6.015c0-.754.728-1.393 1.59-1.393H20.25zm0 13.558c.193 0 .367-.146.39-.207l-.003-11.956a.555.555 0 00-.384-.182H3.746c-.21 0-.364.132-.387.19v11.973c.014.044.171.182.387.182H20.25zM6.152 9.068c0 .554.451 1.005 1.003 1.005a1.006 1.006 0 000-2.01c-.552 0-1.003.45-1.003 1.005zm1.003 2.215a2.216 2.216 0 010-4.43c1.218 0 2.207.993 2.207 2.215a2.213 2.213 0 01-2.207 2.215zm12.42 1.337l-3.18-2.44a.605.605 0 00-.742.005l-3.636 2.9-.879-.83a.6.6 0 00-.798-.025l-5.168 4.317a.607.607 0 00.386 1.07.59.59 0 00.384-.14l4.759-3.975 3.308 3.123c.241.23.625.221.852-.025a.605.605 0 00-.026-.854l-1.932-1.824 3.131-2.496 2.807 2.154a.603.603 0 00.846-.112.609.609 0 00-.112-.848z"
            })
        }) : void 0
    });
}), H = {
    "1:1": 1,
    "16:9": 16 / 9,
    "7:10": 7 / 10,
    "4:3": 4 / 3
}, e1 = /*#__PURE__*/ o.forwardRef((_param, S)=>{
    var { aspectRatio: e = 0, alt: C = "", dataAttributes: d, noBorderRadius: m, src: s, srcSet: a, onError: n, onLoad: l, loadingFallback: M = !0, errorFallback: x = !0 } = _param, i = _object_without_properties(_param, [
        "aspectRatio",
        "alt",
        "dataAttributes",
        "noBorderRadius",
        "src",
        "srcSet",
        "onError",
        "onLoad",
        "loadingFallback",
        "errorFallback"
    ]);
    var I;
    const h = T(), c = o.useRef(), u = i.circular ? $ : m ? p : K, [y, f] = o.useState(!s), [A, g] = o.useState(!1), L = i.width && i.height ? void 0 : i.circular ? 1 : typeof e == "number" ? e : H[e], b = M && !!(L !== 0 || i.width && i.height), B = x && !!(L !== 0 || i.width && i.height), v = o.useCallback(()=>{
        f(!1), c.current && (c.current.style.opacity = "1"), setTimeout(()=>{
            g(!0);
        }, P), l == null || l();
    }, [
        l
    ]);
    o.useEffect(()=>{
        f(!s), g(!1);
    }, [
        s
    ]), o.useEffect(()=>{
        var R;
        (R = c.current) != null && R.complete && v();
    }, [
        v
    ]);
    const N = Q() || !((I = document.getElementById(h)) != null && I.complete), W = /* @__PURE__ */ w(k, {
        children: [
            /* @__PURE__ */ t("img", {
                suppressHydrationWarning: !0,
                id: h,
                style: {
                    opacity: N && b ? 0 : 1
                },
                ref: G(c, S),
                src: s,
                srcSet: a,
                className: E(u, U, {
                    [q]: i.border
                }, D({
                    position: L !== 0 ? "absolute" : "static"
                })),
                alt: C,
                onError: ()=>{
                    f(!0), g(!0), n == null || n();
                },
                onLoad: v,
                decoding: "async"
            }),
            b && /* @__PURE__ */ t("script", {
                dangerouslySetInnerHTML: {
                    __html: `document.getElementById("${h}").addEventListener('load', (e) => e.target.style.opacity = "1")`
                }
            })
        ]
    });
    var _i_height, _i_width;
    return /* @__PURE__ */ w(k, {
        children: [
            b && !A && /* @__PURE__ */ t("div", {
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    overflow: "hidden"
                },
                className: u,
                children: /* @__PURE__ */ t(V, {
                    height: (_i_height = i.height) !== null && _i_height !== void 0 ? _i_height : "100%",
                    width: (_i_width = i.width) !== null && _i_width !== void 0 ? _i_width : "100%",
                    children: /* @__PURE__ */ t(J, {
                        height: "100%",
                        width: "100%",
                        noBorderRadius: !0
                    })
                })
            }),
            y && B && /* @__PURE__ */ t("div", {
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                },
                children: /* @__PURE__ */ t(Y, {
                    border: i.border,
                    className: u
                })
            }),
            !y && W
        ]
    });
}), t1 = /*#__PURE__*/ o.forwardRef((e, C)=>{
    var _e_aspectRatio;
    const d = e.width && e.height ? void 0 : e.circular ? 1 : typeof e.aspectRatio == "number" || !e.aspectRatio ? (_e_aspectRatio = e.aspectRatio) !== null && _e_aspectRatio !== void 0 ? _e_aspectRatio : 0 : H[e.aspectRatio];
    return /* @__PURE__ */ t(_, {
        style: {
            position: "relative"
        },
        aspectRatio: d,
        width: e.width,
        height: e.height,
        dataAttributes: Z(e.dataAttributes, "Image"),
        forceNonCssAspectRatio: e.forceNonCssAspectRatio,
        children: /* @__PURE__ */ t(e1, _object_spread_props(_object_spread({}, e), {
            ref: C
        }))
    });
}), g1 = t1;
export { e1 as ImageContent, Y as ImageError, H as RATIO, g1 as default };
